/* section-collections.js — extracted from sections/collections.liquid */
function clearCollectionsSearch() {
    const input = document.getElementById('collections-search-input');
    const clearBtn = document.getElementById('collections-search-clear');
    if (input) input.value = '';
    if (clearBtn) clearBtn.style.display = 'none';
    handleCollectionsFilterChange();
  }

  function resetAllCollectionFilters() {
    const input = document.getElementById('collections-search-input');
    const clearBtn = document.getElementById('collections-search-clear');
    const sortSelect = document.getElementById('collections-sort-select');

    if (input) input.value = '';
    if (clearBtn) clearBtn.style.display = 'none';
    if (sortSelect) sortSelect.value = 'name-asc';

    handleCollectionsFilterChange();
  }

  function handleCollectionsFilterChange() {
    const input = document.getElementById('collections-search-input');
    const clearBtn = document.getElementById('collections-search-clear');
    const sortSelect = document.getElementById('collections-sort-select');
    const grid = document.getElementById('collections-cards-grid');
    const countLabel = document.getElementById('collections-results-count');
    const emptyView = document.getElementById('collections-empty-view');

    if (!grid) return;

    const query = input ? input.value.trim().toLowerCase() : '';
    if (clearBtn) clearBtn.style.display = query.length > 0 ? 'inline' : 'none';

    const sortVal = sortSelect ? sortSelect.value : 'name-asc';
    const isSaleFilter = (sortVal === 'on-sale');
    const cards = Array.from(grid.querySelectorAll('.collection-edge-card'));

    // 1. Filter matching cards
    let visibleCards = [];
    cards.forEach(card => {
      const title = (card.dataset.title || '').toLowerCase();
      const desc = (card.dataset.desc || '').toLowerCase();
      const isSale = card.dataset.isSale === 'true';

      const matchesSearch = !query || title.includes(query) || desc.includes(query);
      const matchesSale = !isSaleFilter || isSale;

      if (matchesSearch && matchesSale) {
        card.style.display = 'block';
        visibleCards.push(card);
      } else {
        card.style.display = 'none';
      }
    });

    // 2. Sort visible cards
    visibleCards.sort((a, b) => {
      const titleA = (a.dataset.title || '').toLowerCase();
      const titleB = (b.dataset.title || '').toLowerCase();
      const countA = parseInt(a.dataset.count || '0', 10);
      const countB = parseInt(b.dataset.count || '0', 10);
      const initA = parseInt(a.dataset.initialIndex || '0', 10);
      const initB = parseInt(b.dataset.initialIndex || '0', 10);

      switch (sortVal) {
        case 'on-sale':
        case 'name-asc':
          return titleA.localeCompare(titleB);
        case 'name-desc':
          return titleB.localeCompare(titleA);
        case 'count-desc':
          return countB - countA;
        case 'count-asc':
          return countA - countB;
        case 'featured':
        default:
          return initA - initB;
      }
    });

    // Re-append in sorted order
    visibleCards.forEach(card => grid.appendChild(card));

    // 3. Update Results Count and Empty State
    if (countLabel) {
      countLabel.textContent = `${visibleCards.length} COLLECTION${visibleCards.length === 1 ? '' : 'S'}`;
    }

    if (visibleCards.length === 0) {
      grid.style.display = 'none';
      if (emptyView) emptyView.style.display = 'flex';
    } else {
      grid.style.display = 'grid';
      if (emptyView) emptyView.style.display = 'none';
    }
  }

  const __initSectionCollections1 = () => {
    handleCollectionsFilterChange();
  }
  document.addEventListener('DOMContentLoaded', __initSectionCollections1);
  document.addEventListener('shopify:section:load', __initSectionCollections1);
  if (document.readyState !== 'loading') __initSectionCollections1();
